export function obterListaMdfeTipoEmitente() {
  return (
    [
      { label: '1 - Prestador de serviço de transporte', value: 'PRESTADORSERVICOTRANSPORTE' },
      { label: '2 - Transportador de carga própria', value: 'TRANSPORTADORCARGAPROPRIA' },
    ]
  );
}
